import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import type { CameraErrorCause } from '../../types';
import HeaderTitle from '../header-title';
type CameraErrorProps = {
  onBack?: () => void;
  cause: CameraErrorCause;
};
const CameraError = t0 => {
  const $ = _c(18);
  const {
    onBack,
    cause
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.media-errors"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== onBack) {
    t2 = onBack ? {
      variant: "back",
      onBack
    } : undefined;
    $[1] = onBack;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <NavigationHeader leftButton={t2} />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== cause) {
    t5 = $_0 => $_0[cause];
    $[7] = cause;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t || $[10] !== t5) {
    t6 = t(t5);
    $[9] = t;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <HeaderTitle title={t4} subtitle={t6} />;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t7) {
    t8 = <div>{t3}{t7}</div>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default CameraError;
function _temp($) {
  return $.title;
}